import { ShowHidePasswordComponent } from './show-hide-password.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

@NgModule({
  declarations: [ShowHidePasswordComponent],
  exports: [ShowHidePasswordComponent],
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShowHidePasswordModule { }
